<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Wai5kF/tc-custom/9780226352039.jpg?1722575503058" alt="This image is the cover for the book Writer's Diet, Chicago Guides to Writing, Editing, and Publishing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Writer's Diet, Chicago Guides to Writing, Editing, and Publishing
      </h1>
      <p class="bookDescription body article font2">
        <b>“Sword aims to lead us to ‘fit and trim’ prose via an assault course covering horrors such as ‘Prepositional pudge,’ ‘Ad-dictions’ and ‘Waste words.’” —<i>Times Higher Education</i></b><br/><br/>Do your sentences sag? Could your paragraphs use a pick-me-up? If so, <i>The Writer’s Diet</i> is for you! It’s a short, sharp introduction to great writing that will help you energize your prose and boost your verbal fitness.<br/><br/>Helen Sword dispenses with excessive explanations and overwrought analysis. Instead, she offers an easy-to-follow set of writing principles: use active verbs whenever possible; favor concrete language over vague abstractions; avoid long strings of prepositional phrases; employ adjectives and adverbs only when they contribute something new to the meaning of a sentence; and reduce your dependence on four pernicious “waste words”: it, this, that, and there.<br/><br/>Sword then shows the rules in action through examples from William Shakespeare, Emily Dickinson, Martin Luther King Jr., John McPhee, A. S. Byatt, Richard Dawkins, Alison Gopnik, and many more. A writing fitness test encourages you to assess your own writing and get immediate advice on addressing problem areas. While <i>The Writer’s Diet</i> is as sleek and concise as the writing ideals contained within, this slim volume packs a powerful punch.<br/><br/>With Sword’s coaching writers of all levels can strengthen and tone their sentences with the stroke of a pen or the click of a mouse. As with any fitness routine, adhering to the rules requires energy and vigilance. The results, however, will speak for themselves.<br/><br/><b>“Who says nutritious material must be bland? This short book is packed with excellent advice on writing, offered with charm and good cheer.” —Steven Pinker, author of <i>The Sense of Style</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Sword
      </h2>
      
      <p class="authorDescription body article"><B>Helen Sword</B> is professor and director of the Centre for Learning and Research in Higher Education at the University of Auckland. She is the author, most recently, of <I>Stylish Academic Writing</I> and manages the website www.writersdiet.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66e3a92a